<div class="card-header"
     [class.card-header-sm]="size === 'sm'">
  <div class="header-title">
    <p class="card-title">
      <ng-content></ng-content>
    </p>
  </div>
</div>
